import React from "react";

export default function Tables() {
  return <div>Excel_Tables</div>;
}
